module.exports = __webpack_public_path__ + "img/campaign.d4bfaf81.png";